import { HsColor } from '../../../math-new/objects/color.class';
import { HsObject3D } from '../common/object-3d.class';

export abstract class HsLight extends HsObject3D {
  public color: HsColor = new HsColor(1, 1, 1);
  public intensity: number = 1;
  public dynamic: boolean = false;
}
